import {
  FETCH_CHEMISTPAYMENTDETAILS_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CHEMISTPAYMENTDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        chemistPaymentDtlsList: action.payload.rows,
        chemistPaymentDtlsCount: action.payload.count
      };
    default:
      return {
        ...state
      };
  }
}
